import MojitoPresentation from 'mojito/presentation';

import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature, allVisuals} from '../../visual-feature.js';

import {racingConfig} from './racing.factory';

import SCHEMA from './racing.schema.yaml';

const LEGENDS_TYPES_LIST = Object.values(MojitoPresentation.Components.RaceExplanationPane.types.ITEM_TYPES);

class RacingFeature extends AbstractVisualFeature {
    get name() {
        return 'Racing';
    }

    getSerializableVisualConfig() {
        return mergeTo(racingConfig(), {
            RaceExplanationPane: {
                items: {
                    default: LEGENDS_TYPES_LIST.filter(type => !this.config.excludedLegends.default.includes(type)),
                    greyhound_racing: LEGENDS_TYPES_LIST.filter(
                        type => !this.config.excludedLegends.greyhound_racing.includes(type)
                    ),
                },
            },
            HomePage: {
                nextRacesSports: Object.entries(this.config.homepageNextRaces).map(([key, value]) => {
                    return {
                        sportId: key,
                        show: value,
                    };
                }),
            },
        });
    }

    get configSchema() {
        return SCHEMA;
    }
}

export const Racing = FEATURES.racing ? new RacingFeature(allVisuals) : null;
